import { Fragment, FunctionComponent } from 'react';
import { Card, CardContent, Divider, Typography } from '@mui/material';
import { Customer } from '@/models/customer';
import { CardListRow } from '@/components/Card/CardListRow';

const customerKeyLabel = {
    email: 'E-Mail',
    firstname: 'Vorname',
    lastname: 'Nachname',
    salutation: 'Anrede',
    language: 'Sprache',
    phone: 'Telefon',
    city: 'Stadt',
    country: 'Land',
};

const customerKeySort = [
    'salutation',
    'firstname',
    'lastname',
    'phone',
    'language',
    'city',
    'country',
];

type CustomerDetailsCardProps = {
    customer: Customer;
};

export const CustomerDetailsCard: FunctionComponent<
    CustomerDetailsCardProps
> = ({ customer }) => {
    return (
        <Card
            sx={{
                maxWidth: '640px',
            }}
        >
            <CardContent>
                <Typography variant='h6'>Kunde Details</Typography>
            </CardContent>
            <Divider
                sx={{
                    width: '100%',
                }}
            />

            {customerKeySort.map((key) => {
                const label = customerKeyLabel[key];
                const value = customer[key]?.toString() || '-';

                if (!label) return null;

                return (
                    <Fragment key={key}>
                        <CardListRow>
                            <Typography variant='subtitle2'>
                                {customerKeyLabel[key] || key}
                            </Typography>

                            <Typography
                                sx={{
                                    mt: 2,
                                    ml: 2,
                                }}
                            >
                                {value?.toString() || '-'}
                            </Typography>
                        </CardListRow>
                        <Divider
                            sx={{
                                width: '100%',
                            }}
                        />
                    </Fragment>
                );
            })}
        </Card>
    );
};
